import Menu from "./modules/menu";
import Slider from "./modules/slick";
import Theme from "./modules/theme";
// import Intro from "./modules/intro";
import Accordion from "./modules/accordion";
import Form from "./modules/form";

Menu.init();
Theme.init();
Slider.init();
// Intro.init();
Accordion.init();
Form.init();